import { useTheme } from '@emotion/react'

import { StylesHeaderVariables } from '~partials/header/UI'

const StaticWrapper = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{ paddingTop: StylesHeaderVariables(theme).topOffset }}
      {...props}
    />
  )
}

export default StaticWrapper
